// this file is to export the module

module.exports = require("./justgage.js");
